import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useSearchParams } from 'react-router-dom';
import { getPAGAA000, postPAGAB010EventList } from '../../../services/Api';
import ImageCheckFallback from '../../../shared/components/ImageCheckFallback';
import Nav from '../../../shared/components/Nav';
import Pagination from '../../../shared/components/Pagination';
import { MENU_DENTAL_PLUS, BASE_URL } from '../../../shared/constants/app';
import { formatDate, updateMenuVisibility } from '../../../utils';
const PAGAB010 = () => {
    const token = useSelector(({ auth }) => auth.login.token);
    const login = useSelector(({ auth }) => auth.login);
    const loggedIn = login.loggedIn;

    const [listEvent, setListEvent] = useState({});
    const [listEventNotOption, setListEventNotOption] = useState({});
    const [searchParams, setSearchParam] = useSearchParams();
    const page = Number(searchParams.get('page')) || 1;
    const [pages, setPages] = useState({});
    const [isEnd, setIsEnd] = useState('');
    const [keyword, setKeyword] = useState('');
    const [dentalPlusMenu, setDentalPlusMenu] = useState([]);

    useEffect(() => {
        getPAGAA000()
            .then(({ data }) => {
                const updatedDentalPlusMenu = updateMenuVisibility(data, MENU_DENTAL_PLUS);
                setDentalPlusMenu(updatedDentalPlusMenu);
            })
            .catch((error) => console.log(error));
    }, []);

    const inputChange = (e) => {
        setKeyword(e.target.value);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            getListData();
            getListDataNotOption();
        }
    };

    const handleSearchIconClick = () => {
        getListData();
        getListDataNotOption();
    };

    const [itemFilter, setItemFilter] = useState([
        { label: '전체', key: 'countIsEndAll', value: '', active: 1 },
        { label: '진행중', key: 'countIsEndN', value: 'N', active: 0 },
        { label: '마감', key: 'countIsEndY', value: 'Y', active: 0 },
    ]);

    const handleChangeIsEnd = (e) => {
        const dataIsEnd = e.currentTarget.dataset.value;

        setItemFilter((prevFilters) =>
            prevFilters.map((item) => ({
                ...item,
                active: item.value === dataIsEnd ? 1 : 0,
            })),
        );

        if (isEnd !== dataIsEnd) {
            setIsEnd(dataIsEnd);
            setSearchParam(1);
        }
    };
    const getListData = async () => {
        await postPAGAB010EventList({ page, options: { ...(isEnd ? { isEnd: [isEnd] } : {}) }, keyword: keyword })
            .then(({ data }) => {
                setListEvent(data.data);
                setPages(data.info);
            })
            .catch((error) => console.error(error));
    };

    const getListDataNotOption = async () => {
        await postPAGAB010EventList({ page, keyword: keyword })
            .then(({ data }) => {
                setListEventNotOption(data.data);
            })
            .catch((error) => console.error(error));
    };

    useEffect(() => {
        getListData();
        //eslint-disable-next-line
    }, [page, isEnd]);

    useEffect(() => {
        getListDataNotOption();
        //eslint-disable-next-line
    }, [isEnd]);

    return (
        <div id="content">
            <Nav menu={dentalPlusMenu} />
            <div id="tableVolunteer">
                <h3 className="vln__tit">이벤트</h3>
                <div className="header-table">
                    <div className="header-left">
                        {itemFilter.map((item) => (
                            <div
                                key={item.key}
                                className={`item-header ${item.active ? 'active' : ''}`}
                                data-value={item.value}
                                onClick={handleChangeIsEnd}
                            >
                                {item.label} (<span>{listEventNotOption?.statistic?.[0]?.[item.key] || 0}</span>)
                            </div>
                        ))}
                    </div>
                    <div className="header-right gray">
                        <input
                            type="text"
                            placeholder="검색어 입력"
                            value={keyword}
                            onChange={inputChange}
                            onKeyDown={handleKeyDown}
                        />
                        <i className="icon icon-magnifying-glass-line" onClick={handleSearchIconClick}></i>
                    </div>
                </div>

                <div className="vln-event">
                    <ul className={`vln-event__list ${listEvent.list && listEvent.list.length > 0 ? '' : 'empty'}`}>
                        {listEvent.list && listEvent.list.length > 0 ? (
                            listEvent.list.map((item) => (
                                <li className="vln-event__item" key={item.seq}>
                                    {/* <Link
                                        to={`/pagab020-${item?.seq}`}
                                        className="vln-event__link"
                                        onClick={(e) => {
                                            if ((item.eventGbn === 'RVW' || item.eventGbn === 'QUE') && !loggedIn) {
                                                e.preventDefault();
                                                alert('로그인 후 참여하실 수 있습니다.');
                                            }
                                        }}
                                    > */}
                                    <Link
                                        to={`/pagab020-${item?.seq}`}
                                        className="vln-event__link"
                                    >
                                        <picture>
                                            <img
                                                src={`${BASE_URL}/event/${item?.webImg}`}
                                                alt="preview"
                                            />
                                        </picture>

                                        <div className="vln-event__date">
                                            <span className="blue">{item.isEnd === 'N' ? '진행중' : '마감'}</span>
                                            <span>
                                                {formatDate(item.startDate)} ~ {formatDate(item.endDate)}
                                            </span>
                                        </div>

                                        <div className="vln-event__tit">{item.title}</div>
                                    </Link>
                                </li>
                            ))
                        ) : (
                            <li>데이터없습니다</li>
                        )}
                    </ul>
                </div>
                <Pagination pages={pages} />
            </div>
        </div>
    );
};

export default PAGAB010;
